(function () {
  var CUSTOM_VALUE = 'Custom';
  var PROP_NAME = 'properties[Custom Color]';
  var overlay = document.querySelector('[data-ccp-overlay]');
  if (!overlay) return;

  var canvas = overlay.querySelector('[data-ccp-wheel]');
  var ctx = canvas.getContext('2d');
  var brightnessSlider = overlay.querySelector('[data-ccp-brightness]');
  var hexTag = overlay.querySelector('[data-ccp-hex]');
  var previewDot = overlay.querySelector('[data-ccp-preview]');
  var confirmBtn = overlay.querySelector('[data-ccp-confirm]');
  var closeBtn = overlay.querySelector('[data-ccp-close]');

  // 1. Find the hidden input, or create it dynamically inside form[data-product-form]
  var hiddenInput = document.querySelector('[data-ccp-hidden-input]');
  var form = hiddenInput ? hiddenInput.closest('form') : document.querySelector('form[data-product-form]');

  if (!hiddenInput && form) {
    hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.setAttribute('data-ccp-hidden-input', '');
    form.appendChild(hiddenInput);
  }

  var size = 220;
  var center = size / 2;
  var radius = center - 5;
  var currentHex = '';
  var brightness = 50;
  var isDragging = false;

  function hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }

  function hslToRgb(h, s, l) {
    h /= 360;
    s /= 100;
    l /= 100;
    var r, g, b;
    if (s === 0) {
      r = g = b = l;
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hueToRgb(p, q, h + 1 / 3);
      g = hueToRgb(p, q, h);
      b = hueToRgb(p, q, h - 1 / 3);
    }
    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
  }

  function rgbToHex(r, g, b) {
    return '#' + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1).toUpperCase();
  }

  function drawWheel(lightness) {
    var imageData = ctx.createImageData(size, size);
    var data = imageData.data;
    for (var y = 0; y < size; y++) {
      for (var x = 0; x < size; x++) {
        var dx = x - center;
        var dy = y - center;
        var dist = Math.sqrt(dx * dx + dy * dy);
        var idx = (y * size + x) * 4;
        if (dist <= radius) {
          var angle = Math.atan2(dy, dx);
          var hue = ((angle * 180) / Math.PI + 360) % 360;
          var sat = (dist / radius) * 100;
          var rgb = hslToRgb(hue, sat, lightness);
          data[idx] = rgb[0];
          data[idx + 1] = rgb[1];
          data[idx + 2] = rgb[2];
          data[idx + 3] = 255;
        }
      }
    }
    ctx.putImageData(imageData, 0, 0);
  }

  function setColor(hex) {
    currentHex = hex;
    hexTag.textContent = hex;
    previewDot.style.backgroundColor = hex;
  }

  function pickFromCanvas(e) {
    var rect = canvas.getBoundingClientRect();
    var scaleX = size / rect.width;
    var scaleY = size / rect.height;
    var cx, cy;
    if (e.touches) {
      cx = (e.touches[0].clientX - rect.left) * scaleX;
      cy = (e.touches[0].clientY - rect.top) * scaleY;
    } else {
      cx = (e.clientX - rect.left) * scaleX;
      cy = (e.clientY - rect.top) * scaleY;
    }
    var dx = cx - center;
    var dy = cy - center;
    if (Math.sqrt(dx * dx + dy * dy) > radius) return;
    var pixel = ctx.getImageData(Math.round(cx), Math.round(cy), 1, 1).data;
    if (pixel[3] === 0) return;
    setColor(rgbToHex(pixel[0], pixel[1], pixel[2]));
  }

  canvas.addEventListener('mousedown', function (e) {
    isDragging = true;
    pickFromCanvas(e);
  });
  canvas.addEventListener('mousemove', function (e) {
    if (isDragging) pickFromCanvas(e);
  });
  document.addEventListener('mouseup', function () {
    isDragging = false;
  });
  canvas.addEventListener('touchstart', function (e) {
    isDragging = true;
    pickFromCanvas(e);
    e.preventDefault();
  }, { passive: false });
  canvas.addEventListener('touchmove', function (e) {
    if (isDragging) pickFromCanvas(e);
    e.preventDefault();
  }, { passive: false });
  canvas.addEventListener('touchend', function () {
    isDragging = false;
  });

  brightnessSlider.addEventListener('input', function () {
    brightness = parseInt(brightnessSlider.value, 10);
    drawWheel(brightness);
  });

  function openModal() {
    drawWheel(brightness);
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  function confirmColor() {
    if (hiddenInput) {
      hiddenInput.value = currentHex;
      hiddenInput.setAttribute('name', PROP_NAME);
      hiddenInput.disabled = false; 
    }

    var customSwatchColor = document.querySelector(
      '[data-option-value="' + CUSTOM_VALUE + '"] .product__swatch__color'
    );
    if (customSwatchColor) {
      customSwatchColor.style.background = currentHex;
      customSwatchColor.style.backgroundImage = 'none';
    }

    var customSwatchBtn = document.querySelector(
      'button[data-option-value="' + CUSTOM_VALUE + '"]'
    );
    if (customSwatchBtn && !customSwatchColor) {
      customSwatchBtn.style.background = currentHex;
    }

    closeModal();
  }

  closeBtn.addEventListener('click', closeModal);
  confirmBtn.addEventListener('click', confirmColor);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-active')) closeModal();
  });

  function isCustomSelected() {
    var labels = document.querySelectorAll('[data-selected-value-for-option]');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].textContent.trim().toLowerCase() === 'custom') return true;
    }
    return false;
  }

  function handleVariantChange() {
    if (!hiddenInput) return;
    
    if (isCustomSelected()) {
      hiddenInput.setAttribute('name', PROP_NAME);
      hiddenInput.disabled = false;
    } else {
      hiddenInput.removeAttribute('name');
      hiddenInput.disabled = true;
    }
  }

  document.querySelectorAll('[data-option-buttons]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]');
      if (!btn) return;
      var val = btn.getAttribute('data-option-value');
      if (val === CUSTOM_VALUE) {
        setTimeout(openModal, 120);
      }
      setTimeout(handleVariantChange, 50);
    });
  });

  document.querySelectorAll('select[name^="options"]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      if (sel.value === CUSTOM_VALUE) {
        setTimeout(openModal, 120);
      }
      handleVariantChange();
    });
  });

  var observer = new MutationObserver(function () {
    handleVariantChange();
  });
  document.querySelectorAll('[data-selected-value-for-option]').forEach(function (label) {
    observer.observe(label, { childList: true, characterData: true, subtree: true });
  });

  if (form) {
    form.addEventListener('submit', function () {
      if (!isCustomSelected() && hiddenInput) {
        hiddenInput.removeAttribute('name');
        hiddenInput.disabled = true;
      }
    });
  }

  handleVariantChange();
  drawWheel(brightness);
})();